export default {
    'delete-message-section': 'Are you sure you want to delete this section?'

}